<template>
  <div>
    <div v-if="isBusy || loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-1">{{ $t('CATALOG_LOADING_LABEL', {catalog: $t('PERMISSIONS')})  | capitalize}}</strong>
    </div>
    <b-card v-else bg-variant="dark" text-variant="light" :title="$t('PERMISSIONS') | capitalize">
      <b-card-text>
        <b-button class="mb-2" variant="info" @click="showModal">
          {{ $t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('PERMISSIONS')}) | capitalize}}
        </b-button>
        <b-list-group>
          <b-list-group-item variant="dark" :key="permission.id" v-for="permission of current">{{ $t(permission.authority) | capitalize}}
          </b-list-group-item>
        </b-list-group>
        <b-modal :title="$t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('PERMISSIONS')})" id="permission-modal" size="xl" @ok="handleInput">
          <permission-list :currently-selected="currentHrefs" @change="storeSelected"></permission-list>
        </b-modal>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {LoadData, SendsMessages, VModel} from "@/mixins";
import PermissionList from "./PermissionList";

export default {
  name: "PermissionSelector",
  components: {PermissionList},
  props: ['loading', 'value', 'initialValues'],
  mixins: [LoadData, VModel, SendsMessages],
  mounted() {
    this.currentHrefs = this.value;
    this.current = this.initialValues;
  },
  watch: {
    value(val) {
      this.currentHrefs = val;
    },
    initialValues(val) {
      this.current = val;
    }
  },
  methods: {
    storeSelected(selected) {
      this.selected = selected;
      console.log('selected')
      console.log(this.selected);
      this.selectedHrefs = selected.map(x => x._links.self.href);
    },
    async showModal() {
      this.$bvModal.show('permission-modal');
    },
    handleInput() {
      console.log('handle~!');
      console.log(this.selectedHrefs);
      this.$emit('input', this.selectedHrefs);
      this.current = this.selected;
      this.currentHrefs = this.current.map(x => x._links.self.href)
      this.selected = [];
      this.selectedHrefs = [];
    }
  },
  data() {
    return {
      search: '',
      permissions: [],
      content: this.value,
      selected: [],
      selectedHrefs: [],
      current: [],
      currentHrefs: []
    }
  },
}
</script>

<style scoped>

</style>
